<template>
  <div class="h-100">
    <a href="javascript:void(0);" v-b-modal.my-modal-one>Request Quote</a>
    <b-modal id="my-modal-one" ref="modal" title="Request Quote" @hidden="resetModal" @ok="handleOk" size="lg" :ok-title="this.okTitle" :busy="this.busy">
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <div class="form-row">
          <b-form-group :state="nameState" class="col-md-6" label="Name" label-for="name-input" :invalid-feedback="this.errors.name">
            <b-form-input id="name-input" v-model="name" :state="nameState"></b-form-input>
          </b-form-group>
          <b-form-group class="col-md-6" :state="emailState" label="Email" label-for="email-input" :invalid-feedback="this.errors.email">
            <b-form-input id="email-input" v-model="email" :state="emailState" type="email"></b-form-input>
          </b-form-group>
        </div>

        <div class="form-row">
          <b-form-group class="col-md-6" label="Phone" label-for="phone-input">
            <b-form-input id="name-input" v-model="phone"></b-form-input>
          </b-form-group>

          <b-form-group class="col-md-6" label="Company" label-for="company-input">
            <b-form-input id="name-input" v-model="company"></b-form-input>
          </b-form-group>
        </div>

        <div class="form-row">
          <b-form-group class="col-md-12" label="Description" label-for="description-input">
            <b-form-textarea id="textarea" v-model="description" rows="3" max-rows="6"></b-form-textarea>
          </b-form-group>
        </div>

        <div class="col-sm-12 text-right">
          <b-button class="mt-3" variant="danger" d-inline-block @click="$bvModal.hide('my-modal-one')">Cancel</b-button>
          <button d-inline-block class="g-recaptcha mt-3 btn btn-success" :data-sitekey="siteKey" data-callback='onSubmit' data-action='submit' data-size="invisible" variant="primary">{{ okTitle }}</button>
        </div>
      </form>
    </b-modal>
  </div>
</template>


<script>
import axios from "axios";
import BootstrapVue from "bootstrap-vue";
import VueToast from "vue-toast-notification";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "vue-toast-notification/dist/index.css";

Vue.use(VueToast);
Vue.use(BootstrapVue);

export default {
  props: ['item','session'],
  data: function () {
    return {
      name: "",
      nameState: null,
      email: "",
      emailState: null,
      company: "",
      companyState: null,
      description: "",
      phone: "",
      phoneState: null,
      busy: false,
      gRecaptchaResponse: null,
      showMiniCart: false,
      formErrors: {
          name: null,
          email: null,
          phone: null,
          company: null,
          recaptcha: null,
      },
      okTitle: "Submit",
    };
  },
  methods: {
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.nameState = valid ? true : false;
      this.emailState = valid ? true : false;
      this.phoneState = valid ? true : false;
      this.companyState = valid ? true : false;
      return valid;
    },

    resetModal() {
      (this.name = ""),
        (this.nameState = null),
        (this.email = ""),
        (this.emailState = null),
        (this.company = ""),
        (this.description = ""),
        (this.phone = ""),
        (this.okTitle = "Submit"),
        (this.busy = false),
        (this.errors = {
          name: null,
          email: null,
        });
    },
    // onVerify(response) {
    //   this.gRecaptchaResponse = response;
    // },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    handleSubmit() {
      let that = this;
      that.okTitle = "Submitting";
      that.busy = true;
      grecaptcha.ready(function() {
        grecaptcha.execute(that.siteKey, {action: 'submit'}).then(function(token) {
          axios.post(that.url + "/request", {
              name: that.name,
              email: that.email,
              company: that.company,
              description: that.description,
              phone: that.phone,
              segment: that.product,
              item: that.item,
              session_id: that.session,
              g_recaptcha_response: token,
              ga4_session_id: window.ga4_session_id,
            }).then(function (response) {
              Vue.$toast.open({
                message: response.data,
                type: "success",
                duration: 5000,
                dismissible: true,
              });
              that.$nextTick(() => {
                that.$refs.modal.hide();
              });
              that.nameState = null;
              that.formErrors.name = null;
              that.emailState = null;
              that.formErrors.email = null;
              if (error.response.data.errors.name) {
                  that.nameState = false;
                  that.formErrors.name = error.response.data.errors.name[0];
              } else {
                  that.nameState = true;
              }
              that.okTitle = "Submit";
              that.busy = false;
              if (error.response.data.errors.email) {
                  that.emailState = false;
                  that.formErrors.email = error.response.data.errors.email[0];
              } else {
                  that.emailState = true;
              }
              if (error.response.data.errors.phone) {
                  that.phoneState = false;
                  that.formErrors.phone = error.response.data.errors.phone[0];
              } else {
                  that.phoneState = true;
              }
              if (error.response.data.errors.company) {
                  that.companyState = false;
                  that.formErrors.company = error.response.data.errors.company[0];
              } else {
                  that.companyState = true;
              }
              if (error.response.data.errors.g_recaptcha_response) {
                  that.formErrors.recaptcha = error.response.data.errors.g_recaptcha_response[0];
              }
            }).catch(function (error) {
            if (error.response.data.errors.name) {
              that.nameState = false;
              that.errors.name = error.response.data.errors.name[0];
            } else {
              that.nameState = true;
            }
            that.okTitle = "Submit";
            that.busy = false;
            if (error.response.data.errors.email) {
              that.emailState = false;
              that.errors.email = error.response.data.errors.email[0];
            } else {
              that.emailState = true;
            }
            if (error.response.data.errors.phone) {
              that.phoneState = false;
              that.errors.phone = error.response.data.errors.phone[0];
            } else {
              that.phoneState = true;
            }
            if (error.response.data.errors.company) {
              that.companyState = false;
              that.errors.company = error.response.data.errors.company[0];
            } else {
              that.companyState = true;
            }
          });
        });
      });
    },
  },
  mounted() {},
  computed: {
    url: function () {
      return process.env.MIX_API_URL;
    },
    cartUrl: function () {
      return process.env.MIX_MAIN_URL + "/cart";
    },
    baseUrl: function () {
      return window.location.href;
    },
    siteKey: function () {
      return process.env.MIX_GOOGLE_RECAPTCHA_KEY;
    },
  },
};
</script>
<style>
.invalid-feedback {
  color: red;
}
</style>
